import request from './AxiosRequest';

const browseDb = (data) => 
	request({
		url: `/Services/MainService.svc/json/SearchReblast`,
		method: 'POST',
		data: { "criteria": data },
		cancel: true
	});

const browseAzure = (data) => {
	const criteria = {
		AssociatedContentType: data.AssociatedContentType,
		SearchText: data.SearchText,
		ReferralType: data.ReferralType,
		ListingMarketStatus: data.ListingMarketStatus,
		NeighbourHood: data.NeighbourHood,
		GroupId: data.GroupId,
		RecordCount: 20
	}

	if (data.SkipCount){
		criteria.SkipCount = data.SkipCount;
	}
	const strQuery = Object.entries(criteria).map(([key, val]) => `${encodeURIComponent(`criteria[${key}]`)}=${val}`).join('&');
	return request({
		url: `/Services/api/reblast/searchwithcount?${strQuery}&t=${Date.now()}`,
		method: 'GET'
	});
}

const SearchReblast = {
	browseDb,
	browseAzure
}

export default SearchReblast;
